/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, planned: NonNullable<unknown> }} Progress_Consistency_CountInputs */

const en_us2_progress_consistency_count = /** @type {(inputs: Progress_Consistency_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} of 1 workout`);
	return /** @type {LocalizedString} */ (`${i?.done} of ${i?.planned} workouts`)
	
};

const pt_br2_progress_consistency_count = /** @type {(inputs: Progress_Consistency_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 treino`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.planned} treinos`)
	
};

const es_419_progress_consistency_count = /** @type {(inputs: Progress_Consistency_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 entrenamiento`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.planned} entrenamientos`)
	
};

const pt_pt2_progress_consistency_count = /** @type {(inputs: Progress_Consistency_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 treino`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.planned} treinos`)
	
};

const fr_fr2_progress_consistency_count = /** @type {(inputs: Progress_Consistency_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} sur 1 séance`);
	return /** @type {LocalizedString} */ (`${i?.done} sur ${i?.planned} séances`)
	
};

const de_de2_progress_consistency_count = /** @type {(inputs: Progress_Consistency_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} von 1 Training`);
	return /** @type {LocalizedString} */ (`${i?.done} von ${i?.planned} Trainings`)
	
};

const it_it2_progress_consistency_count = /** @type {(inputs: Progress_Consistency_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.planned === 1 || i?.planned === "1")) return /** @type {LocalizedString} */ (`${i?.done} di 1 allenamento`);
	return /** @type {LocalizedString} */ (`${i?.done} di ${i?.planned} allenamenti`)
	
};

/**
* | planned | output |
* | --- | --- |
* | "1" | "{done} of 1 workout" |
* | * | "{done} of {planned} workouts" |
*
* @param {Progress_Consistency_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_consistency_count = /** @type {((inputs: Progress_Consistency_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Consistency_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_consistency_count(inputs)
	if (locale === "es-419") return es_419_progress_consistency_count(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_consistency_count(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_consistency_count(inputs)
	if (locale === "de-DE") return de_de2_progress_consistency_count(inputs)
	if (locale === "it-IT") return it_it2_progress_consistency_count(inputs)
	return en_us2_progress_consistency_count(inputs)
});
export { progress_consistency_count as "progress.consistency_count" }